// Copyright (C) 2020-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT
import React, { useState } from 'react';
import { TableRow, TableCell, Button, Typography, Badge, Box } from '@mui/material';
import Iconify from 'src/components/iconify';
import CVATTooltip from './CVATTooltip';
import CustomPopover from 'src/components/custom-popover/custom-popover';
import { SketchPicker } from "react-color";

const colors = [
    '#33ddff',
    '#fa3253',
    '#34d1b7',
    '#ff007c',
    '#ff6037',
    '#ddff33',
    '#24b353',
    '#b83df5',
    '#66ff66',
    '#32b7fa',
    '#ffcc33',
    '#83e070',
    '#fafa37',
    '#5986b3',
    '#8c78f0',
    '#ff6a4d',
    '#f078f0',
    '#2a7dd1',
    '#b25050',
    '#cc3366',
    '#cc9933',
    '#aaf0d1',
    '#ff00cc',
    '#3df53d',
    '#fa32b7',
    '#fa7dbb',
    '#ff355e',
    '#f59331',
    '#3d3df5',
    '#733380',
];


interface Props {
    value?: string;
    visible?: boolean;
    resetVisible?: boolean;
    onChange?: (value: string) => void;
    onVisibleChange?: (visible: boolean) => void;
    setSelectedColor: any;
    defaultColor? : string;
    selectedColor: any;
}

function ColorPicker(props: Props, ref: React.Ref<any>): JSX.Element {
    const {  selectedColor, visible, resetVisible, onChange, onVisibleChange, defaultColor, setSelectedColor } = props;
    const [pickerVisible, setPickerVisible] = useState(false);


    const changeVisible = (_visible: boolean): void => {
        if (typeof onVisibleChange === 'function') {
            onVisibleChange(_visible);
        } else {
            setPickerVisible(_visible);
        }
    };

    function CustomTitle() {
        return (
            <TableRow sx={{ justifyContent: 'space-between'}}>
            <TableCell colSpan={20}>
              <Typography variant='inherit'>Select color</Typography>
            </TableCell>
            <TableCell colSpan={4} sx={{ justifyContent: 'space-between', alignItems: 'self-end' }}>
              <CVATTooltip title='Close'>
                <Button variant='text' onClick={() => { handleClosePopover(); }}>
                  <Iconify icon={'zondicons:close-outline'} />
                </Button>
              </CVATTooltip>
            </TableCell>
          </TableRow>
        );
    }

    function CustomContent() {
    return (
        <>        
        <TableRow>
            <TableCell colSpan={9}>
                {resetVisible !== false && (
                    <Button

                        onClick={() => {
                            if (typeof onChange === 'function') onChange('');
                            handleClosePopover();
                        }}
                    >
                        Reset
                    </Button>
                )}
            </TableCell>
            <TableCell colSpan={9}>
                <Button
                    className='cvat-color-picker-cancel-button'
                    onClick={() => {
                        handleClosePopover();
                    }}
                >
                    Cancel
                </Button>
            </TableCell>
            <TableCell colSpan={6}>
                <Button variant='contained'
                    onClick={() => {
                        if (typeof onChange === 'function') onChange(selectedColor || '');
                        handleClosePopover();
                    }}
                >
                    Ok
                </Button>
            </TableCell>
        </TableRow>
    </>
    );
    }
    const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);
    const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
        setOpenPopover(event.currentTarget);
      };
    
      const handleClosePopover = () => {
        setOpenPopover(null);
        setSelectedColor(defaultColor)
      };
    

    return (<>
        <CVATTooltip title='Change color of the label'>
            <Button onClick={handleOpenPopover} variant='soft' sx={{maxWidth:"10px"}}>
                {/* <Box sx={{backgroundColor: defaultColor || "#b3b3b3"}}></Box> */}
                <Badge sx={{color: defaultColor || "#b3b3b3"}}>
                    <Iconify  icon={'ph:eyedropper-fill'} />
                </Badge>
            </Button>
        </CVATTooltip>
        <CustomPopover open={openPopover} sx={{ width: 200, p: 0 }}>
            <CustomTitle/>
            <div style={{ marginLeft: '33px' }}>
                <SketchPicker
                    color={selectedColor}
                    onChange={(color: any) => setSelectedColor(color.hex)}
                    presetColors={colors}
                    ref={ref}
                    disableAlpha
                />
            </div>
            <CustomContent/>
        </CustomPopover>
    </>
    );
}

export default React.forwardRef(ColorPicker);
